module.exports = __webpack_public_path__ + "fonts/SpoqaHanSansNeo-Regular.17458b78.woff";